export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12">
          {/* Left text */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-smartphone-line"></i>
              移动端入口
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              随时随地，下拉即看
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              51动漫移动端完美适配手机与平板，支持下拉式连续阅读，无需翻页。
              地铁上、午休时、睡前片刻，打开浏览器就能追最新话，收藏同步、进度不丢。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-3 px-6 py-3 bg-background-50/15 border border-background-50/25 rounded-xl cursor-pointer hover:bg-background-50/25 transition-colors whitespace-nowrap">
                <i className="ri-android-line text-2xl text-background-50"></i>
                <div className="text-left">
                  <div className="text-xs text-background-50/70">Android 版</div>
                  <div className="text-sm font-semibold text-background-50">浏览器访问即可</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-6 py-3 bg-background-50/15 border border-background-50/25 rounded-xl cursor-pointer hover:bg-background-50/25 transition-colors whitespace-nowrap">
                <i className="ri-apple-line text-2xl text-background-50"></i>
                <div className="text-left">
                  <div className="text-xs text-background-50/70">iOS 版</div>
                  <div className="text-sm font-semibold text-background-50">浏览器访问即可</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-shrink-0">
            <div className="relative w-[240px] h-[400px] md:w-[280px] md:h-[460px] rounded-2xl overflow-hidden border-2 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20anime%20manga%20reading%20interface%20with%20warm%20coral%20and%20orange%20accents%2C%20clean%20UI%20design%2C%20Japanese%20anime%20style%20artwork%20on%20screen%2C%20minimal%20device%20frame%2C%20soft%20ambient%20lighting%2C%20professional%20product%20photography%20style%2C%20clean%20white%20background&width=560&height=920&seq=app-mobile-anime-01&orientation=portrait"
                alt="51动漫移动端阅读界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}